export async function getAlarmes() {
    try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/getAlarmes`); // Substitua "URL_DA_API" pela URL real da API
        if (!response.ok) {
            throw new Error(`Erro: ${response.status}`);
        }
        return await response.json();
    } catch (error) {
        console.error("Erro ao buscar dispositivos:", error);
        return [];
    }
}
